// extracted by mini-css-extract-plugin
module.exports = {"iframe-player":"IframePlayer_iframe-player__e3Xoy","relative":"IframePlayer_relative__Zdcqg"};